import { Injectable } from '@angular/core'
import { TmODataConfiguration } from '@exchange/services/core/odata'
import { IModelBase } from 'common-components'
import { HttpClient } from '@angular/common/http'
import { ODataService } from 'common-services'

export interface IClaimAdjustedReceivedDatesView extends IModelBase {
  ClaimId: number
  IsClaimDeleted: boolean
  PatientName: string
  ClaimType: string
  DaysSinceReceived: number
}

@Injectable()
export class ClaimAdjustedReceivedDatesViewODataService extends ODataService<IClaimAdjustedReceivedDatesView> {
  constructor(
    protected http: HttpClient,
    protected config: TmODataConfiguration
  ) {
    super(http, config)
    this.typeName = 'ClaimAdjustedReceivedDatesView'
  }
}
